const component = {
  "取消": "Cancel",
  "完成": "Done",
  "已选中": "Selected",
  "人": "",
  "保存": "Save",
  "请输入userID": "Enter a user ID",
  "请输入groupID": "Enter a group ID",
  "确定": "submit",
  "全选": "All",
  "已在群聊中": "exists"
}

export default component;
